import { render } from "./systemParam.vue?vue&type=template&id=9dc9cbd4&scoped=true"
import script from "./systemParam.vue?vue&type=script&lang=js"
export * from "./systemParam.vue?vue&type=script&lang=js"

import "./systemParam.vue?vue&type=style&index=0&id=9dc9cbd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9dc9cbd4"

export default script